/**
 * @name PortugueseTranslations
 * @description Traducciones en portugués
 */

export const PortugueseTranslations = {
  // *************************************
  // GenericMessages                    
  // *************************************
  GenericMessages: {
    es: 'Español',
    en: 'English',
    pt: 'Português',
    app: 'Aplicativo',
    apps: 'Aplicativos',
    sidebar: 'Menu lateral',
    loading: 'Carregando',
    rows: 'Linhas',
    columns: 'Colunas',
    photo: 'Foto',
    name: 'Nome',
    names: 'Nomes',
    lastName: 'Sobrenome',
    lastNames: 'Sobrenomes',
    job: 'Post',
    area: 'Area',
    branch: 'Filial',
    supervisor: 'Supervisor',
    level: 'Nível',
    levelDescription: 'Descrição do nível',
    gender: 'Gênero',
    male: 'Masculino',
    female: 'Fêmea',
    day: 'Dia',
    days: 'Dias',
    month: 'Mês',
    months: 'Meses',
    year: 'Ano',
    years: 'Anos',
    date: 'Data',
    birthDate: 'Data de nascimento',
    startDate: 'Data de início',
    endDate: 'Data final',
    endOfDate: 'Fecha de final',
    expirationDate: 'Data de expiração',
    registrationDate: 'Data de registro',
    read: 'Ler',
    unread: 'Unread',
    clear: 'Claro',
    open: 'Abrir',
    email: 'Email',
    academicLevel: 'Nível acadêmico',
    phone: 'Número de telefone',
    civilStatus: 'Estado civil',
    seniority: 'Antigo',
    employee: 'Funcionário',
    employees: 'Colaboradores',
    employeeCode: 'Código do colaborador',
    seeOptions: 'Mais opções',
    conversations: 'Conversas',
    survey: 'Sonda',
    agenda: 'Agenda',
    catcher: 'Captura',
    admin: 'Administrador',
    adminOf: 'Gestão',
    of: 'de',
    user: 'Usuário',
    userExternal: 'Usuário externo',
    welcome: 'Bem-vindo!',
    welcomeTalentry: 'Bem-vindo ao Talentry',
    goTalentry: 'Vá para Talentry',
    noErrors: 'Nenhum erro encontrado',
    noResults: 'Nenhum resultado encontrado',
    errorContactAdmin: 'Algo correu mal, contacte o administrador',
    userBlockedContactAdmin: 'Usuário bloqueado, entre em contato com o administrador.',
    languageUpdated: 'O idioma foi atualizado corretamente',
    responsibilities: 'Responsabilidades',
    respProgressTab: 'Avanço das responsabilidades',
    free: 'Grátis',
    all: 'Todos',
    seeAll: 'Ver todos',
    percentage: 'Percentagem',
    current: 'Atual',
    total: 'Total',
    min: 'Mínimo',
    max: 'Máximo',
    chars: 'Caracteres',
    weight: 'Peso',
    sum: 'Soma',
    status: 'Status',
    description: 'Descrição',
    comment: 'Comente',
    comments: 'Comentários',
    sendComment: 'Enviar comentário',
    confirmDeleteComment: 'Tem certeza de que deseja excluir seu comentário?',
    totalOfComments: 'Total de comentários',
    // DataGrid
    show: 'Programa',
    showing: 'Mostrando',
    registers: 'Registros',
    totalItems: 'Total de itens',
    add: 'Adicionar',
    edit: 'Editar',
    delete: 'Remover',
    select: 'Selecionar',
    selectAll: 'Seleccionar tudo',
    unselect: 'Desmarcar',
    unselectAll: 'Desmarcar tudo',
    item: 'Elemento',
    items: 'Elementos',
    noMatches: 'Nenhuma correspondência encontrada',
    exportCSV: 'Exportar um CSV',
    unableToDownload: 'Não é possível fazer o download',
    nextPage: 'Página seguinte',
    previousPage: 'Página anterior',
    sendToAuth: 'Enviar para autorização',
  },
  FormatDates: {
    short: 'DD/MM/YYYY',
    long: 'LL',
    birthday: 'DD/MM',
    shortDate: '{{date, DD/MM/YYYYY}}',
    invalidDate: 'Por favor insira uma data válida',
    invalidMinDate: 'Por favor insira uma data válida. A data não deve ser anterior à data mínima',
  },
  StatusText: {
    yes: 'Sim',
    no: 'Não',
    active: 'Ativo',
    inactive: 'Inativo',
    toBeApproved: 'Para aprovar',
    approved: 'Aprovado',
    rejected: 'Rejeitado',
    notConcluded: 'Não terminou',
    concluded: 'Concluído',
    inRevision: 'Em revisão',
    awaiting: 'Em espera',
    pending: 'Pendente'
  },
  DialogConfirm: {
    approve: 'Aprovar',
    authorize: 'Autorizar',
    save: 'Salvar',
    send: 'Enviar',
    accept: 'Aceitar',
    confirm: 'Confirme',
    continue: 'Continuar',
    cancel: 'Cancelar',
    close: 'Fechar',
    reject: 'Recusar',
    understood: 'Entendido',
    finish: 'Finalizar'
  },
  HttpResponse: {
    error: 'Erro!',
    success: 'Êxito!',
    unauthorized: 'Método não autorizado. Erro 405',
    somethingWentWrong: 'Algo inesperado aconteceu, tente novamente.',
    badRequest: 'Verifique todos os campos.'
  },
  FormsGeneralTexts: {
    required: 'Obrigatório',
    range: 'O intervalo permitido está entre',
    rangeLength: 'O limite de caracteres está entre',
    and: 'e',
    min2Chars: 'Deve conter mínimo de 2 caracteres',
    min3Chars: 'Deve conter mínimo de 3 caracteres',
    min4Chars: 'Deve conter mínimo de 4 caracteres',
    min8Chars: 'Deve conter mínimo de 8 caracteres',
    max20Chars: 'Deve conter máximo de 20 caracteres',
    max25Chars: 'Deve conter máximo de 25 caracteres',
    max100Chars: 'Deve conter máximo de 100 caracteres',
    max250Chars: 'Deve conter máximo de 250 caracteres',
    max500Chars: 'Deve conter máximo de 500 caracteres',
    oneSymbol: 'Deve conter pelo menos um símbolo',
    oneDigit: 'Deve conter pelo menos um número',
    oneCapitalLetter: 'Deve conter uma letra maiúscula',
    oneLowerLetter: 'Deve conter uma letra minúscula',
    onlyDigits: 'Deve conter 0-9 dígitos apenas',
  },
  WeekDays: {
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
    sunday: 'Domingo'
  },
  Months: {
    jan: 'Janeiro',
    feb: 'Fevereiro',
    mar: 'Março',
    apr: 'Abril',
    may: 'Maio',
    jun: 'Junho',
    jul: 'Julho',
    aug: 'Agosto',
    sep: 'Setembro',
    oct: 'Outubro',
    nov: 'Novembro',
    dec: 'Dezembro',
  },
  // *************************************
  // Log In                             
  // *************************************
  Login: {
    sessionStart: 'Log',
    keepSess: 'Não faça logout',
    enterLogIn: 'Entrar',
    forgotPassword: 'Esqueceu sua senha?',
    userEnterpriseId: 'usuário.idempresa',
    password: 'Senha',
    sessionExpired: 'A sessão expirou'
  },
  // *************************************
  // Topbar                             
  // *************************************
  Topbar: {
    home: 'Casa',
    goBack: 'Volte',
    notification: 'Notificação',
    notifications: 'Notificações',
    notificationsCenter: 'Centro de notificação',
    noNotifications: 'Você ainda não tem notificações',
    errorNotifications: 'Notificações não carregadas',
    markAllRead: 'Marcar todos como lidos',
    noApps: 'Você ainda não tem aplicativos atribuídos',
    adminMenu: 'Menu do administrador',
    userMenu: 'Menu usuário',
    setting: 'Configurações',
    onboarding: 'Onboarding',
    logout: 'Logout',
    language: 'Linguagem'
  },
  // *************************************
  // ForgotPassword
  // *************************************
  ForgotPass: {
    retrievePassword: 'Recuperar senha',
    retrieveMSG: 'Se você esqueceu sua senha e não pode acessar sua conta Talentry, digite seu usuário, em breve você receberá uma mensagem para o seu e-mail registrado para que você possa alterar sua senha.',
    retrieve: 'Recuperar',
    procReq: 'Processando seu pedido...',
    invalidUser: 'Você precisa inserir um usuário válido.',
  },
  // *************************************
  // ChangePassword
  // *************************************
  ChangePass: {
    changePass: 'Alterar a sua palavra-passe',
    enterNewPass: 'Digite sua nova senha',
    configProcess: 'O processo de configuração é rápido e fácil, basta digitar sua senha para iniciar a aventura',
    passMustMeet: 'A senha deve estar em conformidade com os seguintes recursos:',
    mustHaveSymDot: 'Ele deve conter pelo menos um caractere diferente de letra ou dígito, o período de exemplo (.), vírgula (,), hífen (-) e assim por diante.',
    mustBetweenDigit0: 'Deve conter pelo menos um número entre 0 e 9.',
    mustHaveMin8Chars: 'Ele deve conter mínimo 8 caracteres.',
    atLeastCap: 'Ele deve conter pelo menos uma letra maiúscula e uma letra minúscula.',
    errorToChangePass: 'Para alterar sua senha você precisa solicitar uma alteração, então você receberá um e-mail que você precisa clicar em.',
    previousPass: 'Palavra-passe anterior',
    newPass: 'Nova senha',
    confirmPass: 'Confirme a senha',
    noPassMatch: 'As senhas não correspondem',
  },
  // *************************************
  // UnlockUser
  // *************************************
  UnlockUser: {
    unlockAccount: 'Desbloqueio de conta',
    userUnlocked: 'Usuário desbloqueado!',
    emailExpiredMSG: 'O email expirou. Para desbloquear sua conta, é necessário que você tente fazer login novamente. Depois, você receberá um novo email no qual é necessário clicar.'
  },
  // *************************************
  // Footer
  // *************************************
  Footer: {
    allRightsReserved: 'Todos os direitos reservados.',
    noticePrivacy: 'Aviso de privacidade',
    termsUse: 'Termos de uso'
  },
  // *************************************
  // Home                            
  // *************************************
  Home: {
    mission: 'Missão',
    vision: 'Visão',
    values: 'Valores',
    goals: 'Metas',
    purpose: 'Objetivo',
    attributes: 'Atributos',
    man: 'Masculino',
    woman: 'Mulheres',
    anniversariesMonth: 'Aniversários trabalhistas em',
    noAnniversariesFound: 'Não há próximos aniversários de trabalho em',
    birthdaysMonth: 'Aniversário em',
    noBirthdaysFound: 'Não há próximos aniversários em',
    today: 'Hoje',
    tomorrow: 'Manhã',
    youExternalUser: 'Você é um usuário externo'
  },
  // *************************************
  // News                            
  // *************************************
  News: {
    news: 'Avisos',
    noNews: 'Sem anúncios',
    seeAllNews: 'Veja todos os avisos',
    all: 'Todos',
    forAll: 'É para todos',
    forSupervisor: 'É para supervisor',
    title: 'Título',
    subject: 'Importa',
    message: 'Mensagem',
    body: 'Corpo',
    noPastDates: 'As datas não devem ser anteriores a hoje e a data de vencimento deve ser igual ou posterior à data de início',
    pastDates2: 'A data de vencimento deve ser igual ou posterior à data de início',
    newsDeleteSuccess: 'Os avisos foram removidos com êxito',
    newsDeleteError: 'Ocorreu um erro ao processar a solicitação',
    addNews: 'Adicionar aviso',
    editNews: 'Editar aviso',
    create: 'Criar',
    sendNews: 'Enviar avisos',
    sendEmail: 'Enviar correio',
    sendNotification: 'Enviar notificação',
    emailSettings: 'Definições de correio',
    sendSettings: 'Configurações de remessa',
    byFilters: 'Por filtros',
    filters: 'Filtros'
  },
  // *************************************
  // Settings
  // *************************************
  Settings: {
    profileConfig: 'Configurações de perfil',
    personalData: 'Dados pessoais',
  },
  // *************************************
  // Responsibilities
  // *************************************
  Responsibilities: {
    responsibility: 'Responsabilidade',
    configByEmployee: 'Definir responsabilidades pelo colaborador',
    seeingMy: 'Você está vendo suas responsabilidades',
    seeingOf: 'Você está vendo as responsabilidades de',
    progressByEmployee: 'Avanços do colaborador',
    toBeApproved: 'Para aprovar',
    revertStatus: 'Status de retorno',
    revertStatusResp: 'Reverter status de responsabilidades',
    rejectResp: 'Rejeitar responsabilidades',
    whyRevertingStatus: 'Por que as responsabilidades estão retornando do status?',
    whyRejectingStatus: 'Por que as responsabilidades estão sendo rejeitadas?',
    minItemsIs: 'O mínimo de elementos é ',
    maxItemsIs: ', o máximo de elementos é ',
    weightTotal: 'e a soma do seu peso deve ser 100',
    minRespIs: 'O número mínimo de responsabilidades é ',
    maxRespIs: ', o número máximo de elementos é ',
    sumRespWeight: ' e a soma do seu peso deve ser 100',
    areaCode: 'Código de área'
  },
  // *************************************
  // UploadFile                    
  // *************************************
  UploadFile: {
    dragAndDrop: 'Arraste e solte seu arquivo ',
    browseFile: 'ou clique aqui para examinar seu dispositivo',
    attachedFile: 'Anexo',
    downloadFile: 'Baixar anexo',
    deleteFile: 'Excluir anexo',
    restoreFile: 'Restaurar arquivo',
    file: 'Arquivo',
    files: 'Arquivos',
    messageFileRejected: 'O arquivo {{fileName}} foi rejeitado. ',
    messageFileTooBig: 'O arquivo é muito grande. O limite de tamanho é {{maxSize}} MB. ',
    messageInvalidType: 'Tipo de arquivo não suportado. ',
    messageAddedFile: 'O arquivo {{fileName}} foi adicionado com sucesso. ',
    messageRemovedFile: 'O arquivo {{fileName}} foi deletado. '
  },
  // *************************************
  // Horario                            
  // *************************************
  Shedule: {
    checkIn: 'Verificar em tempo',
    departure: 'Hora de partida',
    entryHours: 'Horário de entrada',
    departureTime: 'Hora de partida',
    workdays: 'Dias úteis',
    lookingYouShedule: 'Você está olhando para sua programação',
    lookingAtShedule: 'Você está olhando a programação',
    scheduleSetting: 'Configuração de programação',
    scheduleReview: 'Revisão de cronograma',
    whyApproveSchedule: 'Por que você aprova a programação?',
    whyRejectingSchedule: 'Por que você está rejeitando a programação?',
    rejectSchedule: 'Rejeitar programação',
    approveSchedule: 'Aprovar programação',
  },
  // *************************************
  // Backup                            
  // *************************************
  BackupSettings: {
    assignBackup: 'Atribuição de backup',
    backupAssignments: 'Tarefas de backup',
    periodApply: 'Em que período será aplicado?',
    whoYourBackup: 'Quem será seu backup?',
    sureCancelBackup: 'Tem certeza de que deseja cancelar esta atribuição de backup?',
    sureRejectBackup: 'Tem certeza de que deseja rejeitar esta atribuição de backup?',
    commentCancelBackup: 'Escreva um comentário para o cancelamento deste backup:',
    commentRejectBackup: 'Escreva um comentário para o colaborador que selecionou você:',
    cancelBackup: 'Cancelar backup',
    rejectBackup: 'Rejeitar backup',
    infoAlreadyCancel: 'Não é possível cancelar esta atribuição de backup porque ela já foi cancelada.',
    infoNotPossibleCancel: 'Não é possível cancelar esta atribuição de backup.',
    infoNotPossibleCancelstartDate: 'Não é possível cancelar esta atribuição de backup porque a data de início já passou.',
    infoAlreadyReject: 'Não é possível rejeitar esta atribuição de backup porque ela já foi rejeitada.',
    infoNotPossibleReject: 'Não é possível rejeitar esta atribuição de backup.',
    infoNotPossibleRejectTomorrow: 'Não é possível rejeitar esta atribuição de backup porque a data de início é amanhã.',
  },
  // *************************************
  // Cambio de puesto                            
  // *************************************
  Request: {
    actualJob: 'Trabalho atual',
    requiredJob: 'Trabalho requerido',
    jobChange: 'Mudança de emprego',
    lookingYouRequest: 'Você está vendo seus pedidos',
    lookingAtRequest: 'Você está visualizando solicitações de',
    requestReview: 'Revisão de mudança de emprego',
    whyApproveRequest: 'Por que você aprova o pedido?',
    whyRejectingRequest: 'Por que você está rejeitando o pedido?',
    rejectRequest: 'Rejeitar pedido',
    approveRequest: 'Aprovar pedido',
    selectnewJob: 'Selecione sua nova posição',
    warningRequest: 'Ao mudar a posição de um colaborador, se a nova posição tiver uma duração diferente do seu período atual, o período atual será truncado e serão gerados períodos mensais até o início do período correspondente ao cargo para o qual a mudança será feita.'

  },
  // *************************************
  // Notifications                     
  // *************************************
  Notifications: {
    // Gral. Talentry
    adminResponsibilitiesToActive: 'Seu administrador alterou o status de suas responsabilidades para ativo',
    adminResponsibilitiesApproved: 'Seu administrador aprovou suas responsabilidades',
    adminResponsibilitiesRejected: 'Seu administrador rejeitou suas responsabilidades',
    supervisorResponsibilitiesToActive: 'Seu supervisor alterou o status de suas responsabilidades para ativo',
    supervisorResponsibilitiesApproved: 'Seu supervisor aprovou suas responsabilidades',
    supervisorResponsibilitiesRejected: 'Seu supervisor rejeitou suas responsabilidades',
    responsibilitiesToApprove: 'Você tem responsabilidades pendentes para aprovar do <colaborador>',

    // Indicadores
    assignedResultsManager: 'Você foi designado como gerente de resultados',
    suggestedIndicators: 'Você foi sugerido indicadores de catálogo',
    periodPlanApproved: 'Seu plano do <periodo> foi aprovado',
    periodPlanRejected: 'Seu plano do <periodo> foi rejeitado',
    periodResultsAuthorized: 'Seus resultados do <periodo> foram autorizados',
    periodResultsRejected: 'Seus resultados do <periodo> foram rejeitados',
    pendingPlansApprove: 'Você tem planos pendentes para aprovar',
    pendingResultsAuthorize: 'Você tem resultados pendentes para autorizar',
    assignedAsBackup: 'Você foi designado como backup do <colaborador> de <fechaInicio> para <fechaFin>',
    newBackupAssignments: 'Existem novas atribuições de backup',
    adminCancelled: 'O administrador cancelou sua atribuição de backup',
    backupRejected: '<colaborador> rejeitou sua atribuição de backup',
    newIndicatorsCatalogAdded: 'Indicadores foram adicionados ao catálogo',
    backupPeriodEnded: 'Seu período de backup terminou',
    reminderSendPlan: 'Você tem até <fecha> para enviar seu plano de indicador do <periodo>',
    reminderSendResults: 'Você tem até <fecha> para enviar seus resultados do <periodo>',
    reminderSendPlanPeriods: 'Você tem até <fecha> para enviar seu plano de indicadores do <periodo> - <periodoFin>',

    // Reconocimientos
    redeptionCancelled: 'Seu resgate para <premio> foi cancelado',
    deliveryCancelled: 'Sua entrega de <reconocimiento> para <colaborador> foi cancelada',
    pendingPrizeRedeptions: 'Você tem excelentes resgates de prêmios para se registrar',
    assignedKeeperPrizeBranch: 'Você foi designado como responsável pelo prêmio <premio> em <sucursal>',
    assignedKeeperPrize: 'Você foi designado como gerente de prêmios <premio>',
    assignedKeeperDeliveryPrizes: 'Você foi designado como gerente de entrega de prêmios',
    congratulationsAcknowledgements: 'Parabéns! <colaborador> forneceu um <reconocimiento>',
    acknowledgementsToAcknowledge: 'Você recebeu <reconocimiento> para reconhecer',
    timeToAcknowledge: 'É hora de reconhecer!',
    acknowledgementsToRedeem: 'Você foi atribuído <reconocimiento> para resgatar',
    respondAcknowledgements: '<colaborador> respondeu a você pelo reconhecimento que você fez',
    deliveryReceivedCancelled: 'Seu reconhecimento recebido de <colaborador> foi cancelado',

    // Evaluaciones
    chooseFriendsEvaluation: 'Agora você pode escolher seus amigos na avaliação <evento>',
    chosenAsFriendEvaluation: 'Você foi escolhido como amigo de <colaborador> na avaliação <evento>',
    checkResultsEvaluation: 'Revise os resultados da avaliação <evento>',
    timeToEvaluate: 'É hora de avaliar!',
    notFinishEvaluate: 'Você não terminou de avaliar!',
    makeActionPlan: 'Você ainda não tem nenhuma atividade ligada à avaliação <evaluacion>, nós convidamos você a trabalhar em seu plano de ação',


    // Indicadores Acumulados
    accumulatedIndicatorApproved: 'Seu indicador acumulado foi aprovado',
    accumulatedIndicatorRejected: 'Seu indicador acumulado foi rejeitado',
    advancesAccumulatedIndicatorApproved: 'Seus avanços em seu indicador acumulado foram autorizados',
    advancesAccumulatedIndicatorRejected: 'Seus avanços em seu indicador acumulado foram rejeitados',
    pendingAccumulatedIndicators: 'Você acumulou indicadores de seu equipamento aguardando revisão',
    pendingAdvancesAccumulatedIndicators: 'Você tem progresso nos indicadores acumulados de sua equipe, aguardando revisão',

    // Plan de Desarrollo
    activitiesToApprove: 'Você tem atividades pendentes para aprovar',
    activityApproved: 'Sua <actividad> foi autorizada',
    activityRejected: 'Sua <actividad> foi rejeitada',
    suggestionsActivities: 'Você tem sugestões para atividades',
    makeDevelopmentPlan: 'Você ainda não tem nenhuma atividade ligada à avaliação <evaluacion>, nós convidamos você a trabalhar em seu plano de desenvolvimento',
    suggestionReceived: 'Informamos que você tem uma sugestão de atividade no plano de desenvolvimento',

    // Academy
    adminEnrolledToCourse: 'O administrador da Academia inscreveu você no curso <curso>',
    adminSentToWaitingList: 'O administrador da Academia enviou você para a lista de espera do curso <curso>',
    concludeCourse: 'Parabenizamos você por concluir o curso <curso>',
    scheduleModified: 'O horário do curso <curso> foi modificado',
    scheduleCancelled: 'O horário do curso <curso> foi cancelado',
    requestsToReview: 'Você tem solicitações de curso pendentes para revisar',
    requestsToReviewAdmin: 'Você tem solicitações de curso <curso> pendentes para revisar na lista de candidatos',
    suggestedSchedule: '<colaborador> sugeriu uma programação do curso <curso>',
    requestReplacementCourse: '<colaborador> solicitou que você fosse o substituto dele no curso <curso>',
    cancelledSubscription: '<colaborador> cancelou sua inscrição no curso <curso>',
    courseRequestApproved: 'Seu supervisor autorizou sua solicitação para o curso <curso>',
    courseRequestRejected: 'Seu supervisor rejeitou sua solicitação para o curso <curso>',
    replacementCourseAccepted: '<colaborador> aceitou a sua substituição para o curso <curso>',
    replacementCourseRejected: '<colaborador> rejeitou a sua substituição do curso <curso>',
    coursesToReview: 'Você tem solicitações de curso pendentes para revisar',
    replacementCourseExpired: 'Informamos que sua solicitação para substituir o curso <curso> expirou',
    courseStartDate: 'Seu curso <curso> começa em <fecha>',
    courseStartDateInstructor: 'Seu curso <curso> em que você é instrutor inicia a <fecha>',
    newAcademyCourses: 'Existem novos cursos da Academy!',
    courseExpireDate: 'Seu curso <curso> expira em <fecha>',
    courseExpired: 'Seu curso <curso> expirou',
    realesedSpaceEnrolledCourse: 'Um espaço no curso <curso> foi liberado e você foi inscrito',
    notSpaceWaitingList: 'Seu facilitador autorizou sua solicitação para o curso <curso> mas no momento não há lugar e você está na lista de espera',
    answerQuestionary: 'Informamos que a pesquisa do curso <curso> foi iniciada. Você tem até antes de <fecha> para responder.',

    // Comunicación
    assignedToActivity: 'Você foi atribuído à atividade <actividad>',
    assignedToInterview: 'Você foi designado para entrevistar <entrevistado> no evento <tipoEvento>: <evento>',
    startEvent: 'Você iniciou o evento <tipoEvento>: <evento>',
    endEvent: 'O evento <tipoEvento> terminou: <evento>',
    acceptedActivity: '<responsable> aceitou a atividade <actividad>',
    advanceActivity: '<responsable> inseriu um adiantamento na atividade <actividad>',
    concludedActivity: '<responsable> concluiu a atividade <actividad>',
    rejectedActivity: '<responsable> rejeitou a atividade <actividad>',
    assignedDelegate: 'Você foi designado como um representante de <tipoDelegado> no evento <tipoEvento>: <evento>',
    unassignedDelegate: 'Você foi desalocado como um delegado de <tipoDelegado> no evento <tipoEvento>: <evento>',
    scheduledConversation: 'Sua conversa do evento <evento> foi agendada para o <fecha> dia às <hora>',

    // Sueldos y Promociones
    postulateApproved: 'Seu aplicativo <postulado> foi aprovado por <tercerNivel>',
    postulateRejected: 'Seu aplicativo <postulado> foi rejeitado por <tercerNivel>',
    pendingPostulations: 'Você tem aplicativos pendentes para revisar',
    resultsEvent: 'Revise os resultados do evento <evento>',
    salariesEvent: 'Verifique os salários do evento <evento>',
    postulateEmployee: 'Inscreva-se para colaboradores do evento <evento>!',
    timeToVote: 'É hora de votar no evento <evento>!',

    // Reclutamiento
    requestRejectedManager: 'Informamos que o pedido de <colaborador> para a posição <puesto> foi cancelado pelo comitê',
    requestApprovedManager: 'Informamos que a solicitação do <colaborador> para a posição <puesto> foi confirmada pelo comitê',
    requestRejectedSupervisor: 'Sua inscrição para a posição <puesto> foi cancelada pelo comitê',
    requestApprovatedSupervisor: 'Sua inscrição para a posição <puesto> foi confirmada pelo comitê',
    voteDoubt: 'Informamos que um membro do comitê votou em dúvida sobre a solicitação do <colaborador> para a posição <puesto>',
    requestPendingReview: 'Informamos que você tem solicitações pendentes para revisar',
    requestRejected: 'Informamos que sua inscrição para a posição <puesto> foi rejeitada',
    requestCancelledManager: 'Informamos que o supervisor <colaborador> cancelou sua solicitação para a posição <puesto>',
    requestCancelledSupervisor: 'Sua inscrição na posição <puesto> foi cancelada pelo gerente',
    assignedManager: 'Você foi designado como Gerenciador de Solicitações',
    deleteManager: 'Sua atribuição do gerente de aplicativos foi encerrada',
    assignedCommittee: 'Você foi designado como membro do comitê de votação',
    deleteCommittee: 'Sua atribuição como membro do comitê de votação foi encerrada',
    requestConcludedSupervisor: 'Sua inscrição para a posição <puesto> foi concluída pelo gerente',
    requestApprovated: 'Informamos que sua inscrição para a posição <puesto> foi autorizada',
    requestVoteCommitte: 'As informações que uma nova solicitação foi iniciada na votação',

    // Expediente 360
    shedulePending: 'Você tem cronogramas pendentes para aprovar do <colaborador>',
    sheduleApproved: 'Seu supervisor aprovou sua programação',
    sheduleRejected: 'Seu supervisor rejeitou sua programação',
    backupAssigned: '<colaborador> atribuiu você como seu backup de <fechaInicio> a <fechaFin>',
    cancelledBackup: '<colaborador> cancelou o pedido de backup',
    rejectedBackup: '<colaborador> rejeitou seu pedido como um backup',
    contractExpiration: 'Informamos que o contrato <contrato> do <colaborador> irá expirar em <dias> dias',
    jobRequestPending: 'Informamos que você tem solicitações pendentes de mudança de trabalho para revisão',
    jobRequestRejected: 'Informamos que seu supervisor rejeitou sua solicitação de mudança de posição',
    jobRequestApproved: 'Informamos que seu supervisor aprovou sua solicitação de mudança de trabalho',
    endBackup: 'O período de backup terminou',

    // HelpDesk
    myRequestHasBeenAssigned: 'Sua solicitação #<idreporte> foi atribuída a <especialista>',
    myRequestHasBeenReassigned: 'Sua solicitação #<idreporte> foi reatribuída a <especialista>',
    myRequestHasBeenPaused: 'Sua solicitação #<idreporte> foi pausada por <especialista>',
    myRequestHasBeenCanceled: 'Sua solicitação #<idreporte> foi cancelada por <especialista>',
    myRequestHasBeenClosed: 'Sua solicitação #<idreporte> foi fechada por <especialista>',
    addedCommentsMyRequest: '<especialista> adicionou comentários ao seu pedido #<idreporte>',
    haveBeenAssignedRequest: 'Você recebeu um novo pedido #<idreporte>',
    haveBeenReassignedRequest: 'Você reatribuiu a solicitação #<idreporte>',
    addedCommentsRequest: 'Comentários foram adicionados à solicitação #<idreporte>',
    requestEvaluated: '<colaborador> avaliou a atenção do pedido #<idreporte>',
    requestReopened: 'Eles reabriram sua solicitação #<idreporte>',
    configNonWorkingDaysMoment: 'É hora de configurar os dias não úteis da sua empresa'
  }
};